import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const SuperAdminLayout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    { id: 'dashboard', label: 'Dashboard', icon: '📊', path: '/super-admin' },
    { id: 'tenants', label: 'Tenants', icon: '🏢', path: '/super-admin/tenants' },
    { id: 'sites', label: 'Sites', icon: '🏛️', path: '/super-admin/sites' },
    { id: 'analytics', label: 'Analytics', icon: '📈', path: '/super-admin/analytics' },
    { id: 'payment-gateways', label: 'Payment Gateways', icon: '💳', path: '/super-admin/payment-gateways' },
    { id: 'phonepe-tsp', label: 'PhonePe TSP', icon: '📱', path: '/super-admin/phonepe-tsp' },
    { id: 'settings', label: 'Settings', icon: '⚙️', path: '/super-admin/settings' }
  ];

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/');
  };

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 50%, #10b981 100%)' }}>
      {/* Compact Sidebar */}
      <div style={{
        width: '220px',
        background: 'rgba(255, 255, 255, 0.1)',
        backdropFilter: 'blur(20px)',
        borderRight: '1px solid rgba(255, 255, 255, 0.2)',
        padding: '16px 0',
        display: 'flex',
        flexDirection: 'column'
      }}>
        {/* Compact Logo */}
        <div style={{ padding: '0 16px', marginBottom: '20px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <img 
              src="/android-chrome-192x192.png" 
              alt="Tiket Jini Logo" 
              style={{
                width: '32px',
                height: '32px',
                borderRadius: '8px',
                objectFit: 'cover'
              }}
            />
            <div>
              <h2 style={{ margin: 0, color: 'white', fontSize: '16px', fontWeight: '700' }}>
                Tiket Jini
              </h2>
              <p style={{ margin: 0, color: 'rgba(255,255,255,0.7)', fontSize: '10px' }}>
                Super Admin
              </p>
            </div>
          </div>
        </div>

        {/* Compact Menu Items */}
        <nav style={{ flex: 1, padding: '0 12px' }}>
          {menuItems.map(item => (
            <button
              key={item.id}
              onClick={() => navigate(item.path)}
              style={{
                width: '100%',
                padding: '8px 12px',
                margin: '2px 0',
                background: location.pathname === item.path 
                  ? 'rgba(255, 255, 255, 0.2)' 
                  : 'transparent',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                fontSize: '13px',
                fontWeight: '600',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                textAlign: 'left',
                transition: 'all 0.3s ease'
              }}
              onMouseOver={(e) => {
                if (location.pathname !== item.path) {
                  e.target.style.background = 'rgba(255, 255, 255, 0.1)';
                }
              }}
              onMouseOut={(e) => {
                if (location.pathname !== item.path) {
                  e.target.style.background = 'transparent';
                }
              }}
            >
              <span style={{ fontSize: '14px' }}>{item.icon}</span>
              {item.label}
            </button>
          ))}
        </nav>

        {/* Compact Logout */}
        <div style={{ padding: '0 12px', marginTop: '16px' }}>
          <button
            onClick={handleLogout}
            style={{
              width: '100%',
              padding: '8px 12px',
              background: 'rgba(239, 68, 68, 0.2)',
              color: 'white',
              border: '1px solid rgba(239, 68, 68, 0.3)',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '13px',
              fontWeight: '600',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}
          >
            <span>🚪</span>
            Logout
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div style={{ flex: 1, overflow: 'auto' }}>
        {children}
      </div>
    </div>
  );
};

export default SuperAdminLayout;